<template>
  <b-overlay :show="loading" class="row bg-white ">
    <div class="col-12 mt-3">
      <b-form-input
        v-model="search"
        placeholder="Buscar"
        class="form-control"
        data-cy="search"
      />
    </div>
    <div class="col-12 mt-3">
      <b-table-simple hover small responsive>
        <b-thead>
          <b-tr>
            <b-th scope="col">Nº</b-th>
            <b-th scope="col">Fecha Subasta</b-th>
            <b-th scope="col">Coordinadora</b-th>
            <b-th scope="col" class="text-center">
              acciones
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-for="subasta in list" :key="subasta.subastaId"
            data-cy="auction"
            >
            <b-td>
              <div v-tooltip="'Folio subasta'" class="d-flex align-items-center">
                {{ subasta.folio }}
              </div>
            </b-td>
            <b-td class="text-center">
              {{ subasta.fechaSubasta  | dateFormat }}
            </b-td>
            <b-td class="text-truncate w-75">
              <span
                class="text-truncate w-75"
                v-tooltip="subasta.gestoraNombre"
              >
                {{ subasta.gestoraNombre }}
              </span>
            </b-td>
            <b-td class="text-center">
              <b-button
                size="sm"
                variant="outline-danger"
                @click="onPostule(subasta.subastaId)"
                data-cy="postule"
              >
                Seleccionar
              </b-button>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>
    <div class="col-12 text-right">
      <ListPagination
        :show="list.length"
        v-model="page"
        :pages="pages"
        v-on:change="changePage"
      />
    </div>
  </b-overlay>
</template>
<script>

import ListPagination from '@/components/list/ListPagination';
import { auctionBatchesAdd, auctionsListSearch } from '@/febos/servicios/api/aduanas/auctions.api';
import { auctionsStateCode } from '@/febos/aduanas/auctions/views/utils/constants';

export default {
  components: {
    ListPagination
  },
  data() {
    return {
      loading: false,
      search: '',
      list: [],
      pages: 0,
      page: 1
    };
  },
  props: {
    batchIds: {
      type: Array,
      required: true
    }
  },
  watch: {
    search() {
      this.debounceGetList();
    }
  },
  methods: {
    debounceGetList: _.debounce(async function debouncedGetList() {
      this.page = 1;
      await this.getList();
    }, 500),
    async onPostule(id) {
      this.loading = true;
      try {
        await auctionBatchesAdd({ subastaId: id, lotes: this.batchIds });
        this.$emit('postule');
      } finally {
        this.loading = false;
      }
    },
    changePage(page) {
      this.page = page;
      this.getList();
    },
    async getList() {
      this.loading = true;
      const { auctionId } = this.$route.params;
      let filters = `estado:${auctionsStateCode.preparacion}`;
      if (auctionId) {
        filters = filters.concat(`|subastaId:${auctionId}`);
      }
      const {
        data: {
          documentos,
          totalPaginas
        }
      } = await auctionsListSearch(
        { query: this.search, filters, page: this.page }
      );
      this.list = documentos;
      console.log('list', this.list);
      this.pages = totalPaginas;

      this.loading = false;
    }
  },
  async created() {
    this.loading = false;
    await this.getList();
  }
};
</script>
